/* ── GoAffPro — Configuration Emmera ───────────────────────────────────── */
window.goaffproConfig = {
  shop: "fr-fegyna.myshopify.com",

  program: {
    commissionRate: 15,
    commissionType: "percentage",
    cookieDuration: 30,
    minimumPayout: 30,
    payoutSchedule: "monthly",
    payoutDay: 1,
    validationDelay: 30
  },

  couponFormat: "{NAME}15",

  branding: {
    primaryColor: "#6B8F71",
    secondaryColor: "#C4856A",
    accentColor: "#C9A96E",
    fontFamily: "DM Sans, sans-serif",
    programName: "Programme Ambassadrices",
    storeName: "Emmera"
  },

  emails: {
    welcomeSubject: "Bienvenue dans le programme, {firstName}",
    welcomeBody: "Bonjour {firstName}, bienvenue dans le programme ambassadrices Emmera. Ton lien unique est pret.",
    paymentSubject: "Ton virement de {amount} est en route",
    replyTo: "ambassadrices@emmera.fr"
  },

  dashboard: {
    showEarnings: true,
    showClicks: true,
    showConversions: true,
    showPayments: true,
    showLinks: true,
    showCoupons: true,
    showAssets: true
  }
};
